/* eslint-disable require-jsdoc */

export const stylers = {

  /**
   * Map Styler JSON
   */
  styles: [
    {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
    {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{color: '#d59563'}],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{color: '#d59563'}],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{color: '#263c3f'}],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{color: '#6b9a76'}],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{color: '#38414e'}],
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{color: '#212a37'}],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{color: '#9ca5b3'}],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{color: '#746855'}],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{color: '#1f2835'}],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{color: '#f3d19c'}],
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{color: '#2f3948'}],
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{color: '#d59563'}],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{color: '#17263c'}],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{color: '#515c6d'}],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{color: '#17263c'}],
    },
  ],

  /**
    * Map Icon/Pin SVG
    * SVG is base64 encoded.
    */
  icons: {
    // eslint-disable-next-line max-len
    red: 'data:image/svg+xml;base64,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',
    // eslint-disable-next-line max-len
    hearbyEvents: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAiCAYAAABFlhkzAAADqUlEQVRIx52WW2hcVRSGv7U9mUx02oi9OElMa0ybaWnshcCMYqEgtPQhiFgQQYvoi/SpCJVCCy0IKVQrQQOC7YP0qVqwqGAb+hDoQ8CxxCaNqZ2Zpo2GJkdi00ZyGSdzzvIhl5rJnJMzs54Oe//7/8/e+99rLcEjfolFw+qyS9HXgFeBBuDp+elHwD2gS5AfxXAjnrKzxXikcCAZixpUd6lyGNgPrC2Gmw8F/gY6RfgckRuJlO16CiSbomGFd1E9DtRTWgwj0iZwPpF+vBv5PzmqRxSOAhHKi0ngtIicWRAxANe31hhUDwYiF/GbjQBHUT14fWuNWRRwHW1WOBbkz6tf2UN4w/O+IgrHXEebAUwyVluhqoeAjUHOYFVLnBdOf8FTzdv9drNRVQ8lY7UVBtfdArT6OGXZEa1qidN45ktWv7zbS0SAVlx3i0HYB9SWcpOayxFau46Gjz8lsqPFC1aLsM+o6t6FuwgaM0ODZD78gH+H/+C5wx/xxOrqYjCjqnsNECvVizo7y9TNXoY/O0VlXT1VjZu9oDEDrC/T88zcvUN26C5iPA9gvQHC5Qrg5Jns+5WZwYwXImyAXLn8ms/z14Xz5B899ILkDDBetoDjkB9/4AcZt4BBX5saQ+jZGqo2NWHCYSrrSsqBgxZCF8ruYg/NVIZZ9+bbRN95n1BdPWJZ4LpMp24F2qAIXUaQK8BYMcQz+1vZcOQ44YZGTCiEGINYFuo4qOuuJDAGcsWI0Adc9UpspurJpYOuy2RvD+701EoCV0XoM/GUnRWRDuB+IWKi+9oSh+T/mWDs0reMnO1AHceP/L6IdMRTdtaau0ftcRxpBz0FhBZQD376geyfQ0Re3Ik6DlO3fmP6937cbNaPPAe0G6M9BRWtplrV/Rp4PXBmLV6jvxeR9xJpe2JZTf65Kbod1e+ATWUK3EHkwEtp++aiE5fYEvoFaQOmyiCfEqTNQH8B5+OIp20FuQhcANwSyN25NXJxjsOnLwJIbo42KHoJ2BlQoFeQNxIZ+96yx1oMbSFDgpyc7+BWiocictJChopmmmKDLZlRRaQT+ArwM7wDnAXpbMmMaqDWsaDTi6rqN8AeD8g1EXkrkbZtz1zp2+BUrLFF5AQwWmR6VERORCrW2H4cvgLbBgYQY7qB9oLClAPaxZjubQMDlC0AEL894ojIOeDy/EtV4LKInIvfHnFWbKOCGj3ZFN2hc68cETmQSNt9QdZZQQXEqugnP/vJ4nfA+A/fSUn8A26hXAAAAABJRU5ErkJggg==',
  },
};
